module.exports = __webpack_public_path__ + "1.93074c953d7b2f4de694.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Home/OneDrive/Documents/hotellife_web/src/assets/images/bg/1.jpg
// module id = ../../../../../src/assets/images/bg/1.jpg
// module chunks = styles